import React from "react";

import "./stylesUserCard.css";

import EditIcon from "../../../assets/icons/ic_edit.svg";
import CoinIcon from "../../../assets/icons/ic_coins.svg";
import CashIcon from "../../../assets/icons/ic_cash.svg";
import FreeCashIcon from "../../../assets/icons/ic_free-cash.svg";
import BronzeIcon from "../../../assets/icons/ic_bronze-status.svg";
import Avatar from "../../../assets/icons/avatar.png";

import { Pause, User, UserX } from "react-feather";

function UserCard() {
  return (
    <div className="user-card-container">
      <div className="user-card-header">
        <div className="bagde-active">Active</div>
        <div className="bagde-bettor">
          <img src={BronzeIcon} alt="bronze icon" />
          BRONZE BETTOR
        </div>
        <img src={Avatar} alt="avatar" />
        <div className="username-container">
          <p className="name">Jane Cooper</p>
          <p className="username">LuckyPlayer</p>
        </div>
      </div>
      <div className="indices">
        <div className="total-purchases border-right">
          <p>
            Total <br /> Purchases
          </p>
          <span className="orange">$12,5k</span>
        </div>
        <div className="total-prize-redemptions border-right">
          <p>
            Total Prize <br /> Redemptions
          </p>
          <span className="orange">$2,8k</span>
        </div>
        <div className="lifetime-value">
          <p>
            Lifetime <br /> Value
          </p>
          <span className="green">+$2,4k</span>
        </div>
      </div>
      <div className="buttons">
        <button className="button-suspend">
          <Pause size={16} />
          Suspend
        </button>
        <button className="button-delete">
          <UserX size={16} />
          Delete
        </button>
      </div>
      <div className="referral-code">
        <p className="code">U-GOL-UAB-08</p>
        <p className="placeholder">Referral Code</p>
      </div>
      <div className="user-balance">
        <div className="top">
          <p>User balance</p>
          <img src={EditIcon} alt="edit icon" />
        </div>
        <div className="rebet-cash">
          <div>
            <img src={CashIcon} alt="cash icon" />
            <p>Rebet Cash</p>
          </div>
          <span>24,000.00</span>
        </div>
        <div className="rebet-coins">
          <div>
            <img src={CoinIcon} alt="coin icon" />
            <p>Rebet Coins</p>
          </div>
          <span>400,000.00</span>
        </div>
        <div className="rebet-free-cash">
          <div>
            <img src={FreeCashIcon} alt="free cash icon" />
            <p>Free Cash</p>
          </div>
          <span>10,000.00</span>
        </div>
        <div className="limits">
          <div className="top">
            <p>Limits</p>
            <span>No limits</span>
          </div>
          <button>Add Limits</button>
        </div>
      </div>
    </div>
  );
}

export default UserCard;
